import React from "react";
import { PageBanner } from "../components/common";
import ContactSection from "../sections/ContactSection";
import { MapPin } from "lucide-react";
import { company } from "../mock";

const ContactPage = () => {
  return (
    <main>
      <PageBanner
        title="Contact Us"
        crumb="Contact"
        image="https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <ContactSection />
      <section className="pb-24 bg-[#F1F3F7]">
        <div className="max-w-[1320px] mx-auto px-5">
          <div className="rounded-lg overflow-hidden shadow-sm relative">
            <iframe
              title="Salmons Brothers location"
              src="https://www.google.com/maps?q=61+Lancaster+Way,+Ely,+Cambridgeshire+CB6+3NW&output=embed"
              className="w-full h-[420px] border-0"
              loading="lazy"
            />
            <div className="absolute top-6 left-6 bg-white rounded-lg px-6 py-4 shadow-lg flex items-center gap-3 max-w-xs">
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-full bg-[#CD0008] text-white">
                <MapPin size={20} />
              </span>
              <span className="text-sm font-medium text-[#0B102D]">{company.address}</span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
